import { theme } from '@/components';
import type { CSSProperties } from 'react';

export type ColorOptions =
  | 'gray'
  | 'white'
  | 'magenta'
  | 'blue'
  | 'cyan'
  | 'gold'
  | 'green'
  | 'purple'
  | 'red';

export const getTagStyles = (color: ColorOptions): CSSProperties => {
  const { token } = theme.useToken();
  const grayColor = {
    backgroundColor: '#f0f0f0',
    borderColor: '#d9d9d9',
    color: `${token.colorTextBase}`,
  };

  switch (color) {
    case 'gray':
      return grayColor;
    case 'white':
      return {
        backgroundColor: '#ffffff',
        borderColor: '#d9d9d9',
        color: `${token.colorTextBase}`,
      };
    case 'magenta':
      return {
        backgroundColor: '#fff0f6',
        borderColor: '#ffadd2',
        color: '#780650',
      };
    case 'blue':
      return {
        backgroundColor: '#e6f7ff',
        borderColor: '#91d5ff',
        color: '#2f54eb',
      };
    case 'cyan':
      return {
        backgroundColor: '#e6fffb',
        borderColor: '#87e8de',
        color: '#00474f',
      };
    case 'gold':
      return {
        backgroundColor: '#fffbe6',
        borderColor: '#ffe58f',
        color: '#874d00',
      };
    case 'green':
      return {
        backgroundColor: '#f6ffed',
        borderColor: '#b7eb8f',
        color: '#135200',
      };
    case 'purple':
      return {
        backgroundColor: '#f9f0ff',
        borderColor: '#d3adf7',
        color: '#22075e',
      };
    case 'red':
      return {
        backgroundColor: '#fff1f0',
        borderColor: '#ffa39e',
        color: '#820014',
      };
    default:
      return grayColor; // Just in case, setting the gray color as default
  }
};
